import styled from 'styled-components';

export const Container = styled.div``;

export const VideoPreview = styled.video`
  width: 100%;
  height: 200px;
`;
